import { createFileRoute } from '@tanstack/react-router';
import { SuppliersClient } from '@/features/fuel/SuppliersClient';

export const Route = createFileRoute('/_shell/fuel/suppliers')({
  component: SuppliersClient,
});
